module.exports = __webpack_public_path__ + "static/media/defaultImage.a68e39a7.svg";